import React from 'react';
import './PrivacyPolicy.css';

export const TERMS_OF_SERVICE_VERSION = '2026-09-06';
const CONTACT_EMAIL = 'c.albuq78@gmail.com';

export function TermsOfServiceContent() {
  return (
    <div className="pp-content">
      <p className="pp-updated">Última atualização: 06/09/2026</p>

      <p>
        Estes Termos de Serviço regulam o uso do Life Assistant, aplicativo de
        organização pessoal (saúde, agenda, alimentação, treino, finanças e
        e-mails) mantido por Cristiano Albuquerque. Ao criar uma conta, você
        concorda com estes termos e com a{' '}
        <a href="/privacidade">Política de Privacidade</a>.
      </p>

      <h3>1. O que é o serviço</h3>
      <p>
        O Life Assistant reúne, num único painel, informações que você mesmo
        conecta ou cadastra (saúde, calendário, e-mails, notas, composição
        corporal, treinos, alimentação) e oferece análises e sugestões geradas
        por Inteligência Artificial com base nesses dados. É uma ferramenta de
        organização pessoal — não substitui acompanhamento médico,
        nutricional, físico ou financeiro profissional.
      </p>

      <h3>2. Cadastro e conta</h3>
      <p>
        Você precisa ter 18 anos ou mais pra criar uma conta. É responsável por
        manter sua senha em sigilo e por tudo que acontecer usando sua conta.
        Avise imediatamente pelo e-mail{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> se suspeitar de
        uso não autorizado.
      </p>

      <h3>3. Uso aceitável</h3>
      <p>Ao usar o Life Assistant, você concorda em não:</p>
      <ul>
        <li>Tentar acessar dados de outros usuários ou burlar a autenticação;</li>
        <li>Usar o app pra fins ilegais ou pra armazenar conteúdo que viole direitos de terceiros;</li>
        <li>Abusar deliberadamente das funções de IA do sistema (ex.: automatizar chamadas em massa) de um jeito que prejudique o serviço pra outros usuários.</li>
      </ul>
      <p>Podemos suspender ou encerrar contas que violem estas regras.</p>

      <h3>4. Sugestões e análises por Inteligência Artificial</h3>
      <p>
        O conteúdo gerado por IA (análises de saúde/treino, sugestões de
        cardápio ou de rotina de exercícios, frases motivacionais) é uma
        estimativa geral baseada nos dados que você forneceu — não é
        aconselhamento médico, nutricional ou de treinamento físico
        profissional, e pode conter imprecisões. Decisões sobre sua saúde,
        alimentação ou treino devem ser validadas com um profissional
        qualificado.
      </p>

      <h3>5. Sua própria chave de IA (BYOK)</h3>
      <p>
        Se você cadastrar sua própria chave de API da Anthropic nas
        Preferências, qualquer custo de uso dessa chave é de sua
        responsabilidade exclusiva, cobrado diretamente pela Anthropic — o
        Life Assistant não intermedeia nem se responsabiliza por essa cobrança.
      </p>

      <h3>6. Integrações de terceiros</h3>
      <p>
        Ao conectar Google, Microsoft, Instagram ou outro serviço, você
        autoriza o Life Assistant a acessar sua própria conta nesses serviços,
        sujeito também aos termos de uso de cada um deles. Você pode
        desconectar qualquer integração a qualquer momento nas Preferências.
      </p>

      <h3>7. Disponibilidade do serviço</h3>
      <p>
        O Life Assistant é um projeto em crescimento, operado em
        infraestrutura própria, sem garantia contratual de disponibilidade
        (SLA). Podemos ter períodos de indisponibilidade pra manutenção ou por
        motivos técnicos, e podemos alterar ou descontinuar funcionalidades
        conforme o app evolui.
      </p>

      <h3>8. Encerramento da conta</h3>
      <p>
        Você pode pedir a exclusão da sua conta e de todos os dados associados
        a qualquer momento, pelo e-mail{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> — ver detalhes
        na <a href="/privacidade">Política de Privacidade</a>.
      </p>

      <h3>9. Limitação de responsabilidade</h3>
      <p>
        O Life Assistant é fornecido "como está". Na máxima extensão permitida
        pela lei, não nos responsabilizamos por decisões tomadas com base nas
        análises ou sugestões geradas pelo app, nem por indisponibilidade,
        perda de dados ou danos indiretos decorrentes do uso do serviço.
      </p>

      <h3>10. Alterações destes termos</h3>
      <p>
        Podemos atualizar estes termos conforme o app evolui. A data no topo
        desta página sempre mostra a versão mais recente.
      </p>

      <h3>11. Lei aplicável e contato</h3>
      <p>
        Estes termos são regidos pela lei brasileira. Dúvidas:{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </div>
  );
}

export function TermsOfServiceModal({ onClose }) {
  return (
    <div className="pp-backdrop" onClick={onClose}>
      <div className="pp-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pp-modal-head">
          <h2>Termos de Serviço</h2>
          <button className="pp-close" onClick={onClose} aria-label="Fechar">✕</button>
        </div>
        <div className="pp-modal-body">
          <TermsOfServiceContent />
        </div>
      </div>
    </div>
  );
}

export default TermsOfServiceContent;
